// btw-front/src/components/ui/Textarea.jsx
import React from "react";

export function Textarea({
  label,
  required = false,
  error,
  hint,
  maxLength,
  value = "",
  className = "",
  rows = 4,
  id,
  ...rest
}) {
  const inputId = id || rest.name || undefined;
  const len = typeof value === "string" ? value.length : 0;
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      {label && (
        <label htmlFor={inputId} className="text-xs font-medium text-slate-700">
          {label}
          {required && <span className="ml-0.5 text-rose-500">*</span>}
        </label>
      )}
      <textarea
        id={inputId}
        rows={rows}
        maxLength={maxLength}
        value={value}
        className={`rounded-lg border bg-white px-3 py-2 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:ring-2 focus:ring-accent/30 ${
          error ? "border-rose-400 focus:border-rose-500" : "border-slate-300 focus:border-accent"
        }`}
        aria-invalid={!!error}
        {...rest}
      />
      <div className="flex items-center justify-between gap-2">
        {error ? (
          <p className="text-xs text-rose-600">{error}</p>
        ) : hint ? (
          <p className="text-xs text-slate-500">{hint}</p>
        ) : (
          <span />
        )}
        {maxLength && (
          <span className="text-[11px] tabular-nums text-slate-400">
            {len}/{maxLength}
          </span>
        )}
      </div>
    </div>
  );
}
